import React from "react";
import { WhoWeArePageAnimator } from "../../components/who-we-are-page-animator";
import Header from "../common/header";
import { TeamSection } from "../../components/team-section";
import { CompanyProfile } from "../../components/company-profile";
import { MissionVisionValues } from "../../components/mission-vision-values";
import { Milestones } from "../../components/milestones";
import Footer from "../common/footer";

const AboutUs = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <WhoWeArePageAnimator />
      <Header />

      <main className="flex-grow pt-24 md:pt-32">
        {/* MD’s Message Section */}
        <section id="our-story" className="py-16 gsap-wwa-section">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              {/* Image on the left */}
              <div className="md:col-span-1 order-first md:order-first">
                <img
                  src="/global/HANI.webp"
                  alt="MD of Uber E-Visa"
                  width={500}
                  height={600}
                  className="object-cover mx-auto"
                />
              </div>

              {/* Text on the right */}
              <div className="md:col-span-1 order-last md:order-last">
                <h2 className="text-primary font-semibold mb-4">
                  MD&apos;S MESSAGE
                </h2>
                <div className="space-y-6 text-muted-foreground text-lg">
                  <p>
                    “At UBER E-Visa, our journey began with a clear mission – to
                    simplify and modernize the visa process for travellers,
                    professionals and global citizens. In a world that moves
                    fast, we believe access to travel shouldn’t be slowed down
                    by complex paperwork or uncertain procedures.”
                  </p>
                  <p>
                    “Our team is committed to delivering secure, efficient and
                    customer-friendly visa solutions powered by technology and
                    backed by trust. Whether for tourism, business or
                    relocation, we stand by our promise to make every client’s
                    experience smooth, transparent and reliable.”
                  </p>
                  <p className="text-primary font-semibold">
                    “Thank you for choosing UBER E-Visa – where borders meet
                    innovation.”
                  </p>
                  <p className="font-bold text-neutral-800 text-left mt-4">
                    - Hani Ebrahim
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission, Vision, Values Section */}
        <section
          id="mission-vision"
          className="py-16 bg-gray-50 gsap-wwa-section"
        >
          <div className="custom-container mx-auto px-4 max-w-7xl">
            <MissionVisionValues />
          </div>
        </section>

        {/* Company Profile Section */}
        <section
          id="company-profile"
          className="py-16 bg-white gsap-wwa-section"
        >
          <div className="custom-container mx-auto px-4 max-w-7xl">
            <CompanyProfile />
          </div>
        </section>

        {/* Team Section */}
        <section id="team" className="py-16 bg-gray-50 gsap-wwa-section">
          <div className="custom-container mx-auto px-4 max-w-7xl">
            <TeamSection />
          </div>
        </section>

        {/* Milestones Section */}
        <section id="milestones" className="py-16 bg-white gsap-wwa-section">
          <div className="custom-container mx-auto px-4 max-w-7xl">
            <Milestones />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutUs;
